import type { IconProps } from 'common-types';

export const ArrowRight = ({ width = 24, height = 25, fill, ...props }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill={fill ?? 'none'}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.586 11.5L11.293 6.20704C11.1108 6.01844 11.01 5.76584 11.0123 5.50364C11.0146 5.24144 11.1198 4.99063 11.3052 4.80522C11.4906 4.61981 11.7414 4.51465 12.0036 4.51237C12.2658 4.51009 12.5184 4.61088 12.707 4.79304L19.707 11.793C19.8231 11.9088 19.9089 12.0513 19.957 12.208C19.9828 12.2941 19.997 12.3832 19.999 12.473V12.521C19.997 12.6109 19.9828 12.7 19.957 12.786C19.9089 12.9428 19.8231 13.0853 19.707 13.201L12.707 20.201C12.5184 20.3832 12.2658 20.484 12.0036 20.4817C11.7414 20.4794 11.4906 20.3743 11.3052 20.1889C11.1198 20.0035 11.0146 19.7526 11.0123 19.4904C11.01 19.2282 11.1108 18.9756 11.293 18.787L16.586 13.5H5C4.73478 13.5 4.48043 13.3947 4.29289 13.2071C4.10536 13.0196 4 12.7653 4 12.5C4 12.2348 4.10536 11.9805 4.29289 11.7929C4.48043 11.6054 4.73478 11.5 5 11.5H16.586Z"
      fill={fill ?? '#14171A'}
    />
  </svg>
);
